import { BaseDto } from '@/shared/dtos/base-dto';

export class ventas_cabecera extends BaseDto {
    public client_id!: number;
    public tipo_documento!: string;
    public fecha!: Date;
    public estado!: string;
    public total_amazon!: number;
    public base_imponible!: number;
    public total_coste!: number;
    public beneficio_neto!: number;
    public margen_medio!: number;
    public iva!: number;
    public recargo_equivalencia!: number;
    public precio_envio!: number;
    public impuestos!: number;
    public total!: number;
    public notas!: string;
    public id_carrito_origen!: number | null;
}
